<template>
  <v-menu v-if="workspaces && workspaces.length" offset-y light class="z4">
    <template #activator="{ on }">
      <v-btn
        outlined
        dark
        v-on="on"
      >
        {{ currentWorkspace.name }}
        <v-icon right dark>mdi-wallet-travel</v-icon>
      </v-btn>
    </template>

    <v-list light class="mt-2 overflow-auto max-height-300">
      <v-list-item
        v-for="workspace in workspaces"
        :key="workspace.code"
        class="pointer"
        @click="changeCurrentWorkspace(workspace)"
      >
        <v-list-item-title>{{ workspace.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { computed } from '@vue/composition-api';
import store from '@/store';
import { changeWorkspace } from '../../helpers/utils';

export default {
  name: 'WorkspacesPicker',
  setup () {
    const workspaces = computed(() => store.getters.allowedWorkspaces);

    const currentWorkspace = computed(() => store.state.workspace);

    const changeCurrentWorkspace = async receivedWorkspace => {
      await changeWorkspace(receivedWorkspace);
    };

    return { workspaces, currentWorkspace, changeCurrentWorkspace };
  }
};
</script>
